<script lang="ts">
  import {onDestroy} from 'svelte';
  import {events} from '../RemotionElements/Util';
  import {recap} from '@/store';

  let fontFamily = 'default';

  function openFontSelection() {
    dispatchEvent(new Event(events.sideBarPopUpOpen));
  }

  const recapSubscription = recap.subscribe(value => {
    const composition = value.composition;
    if (!composition) return;
    for (let i = 0; i < composition.length; i++) {
      const element = composition[i];
      if (element.type === 'subtitle-element' && element.properties) {
        fontFamily = element.properties?.fontFamily || 'default';
      }
    }
  });

  onDestroy(() => {
    recapSubscription();
  });
</script>

<div class="flex w-full justify-between pb-4">
  <span class="flex w-full items-center font-medium">Primary Font</span>
  <button
    on:click={openFontSelection}
    class="flex h-12 w-full items-center justify-center overflow-hidden rounded-lg border px-6"
    style="max-width: 240px; font-family: {fontFamily === 'default' ? '' : fontFamily}"
  >
    <p>{fontFamily}</p>
  </button>
</div>
